import { Reveal } from "./Reveal";
import { PROCESS } from "../../data";

export const Manifesto = () => {
  return (
    <section id="process" data-testid="process" className="relative py-28 lg:py-40 border-t border-hairline">
      <div className="mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <Reveal>
                <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Our Process</span>
                <h2 className="font-serif font-light text-5xl sm:text-6xl tracking-tighter text-parchment mt-6 text-balance">
                  Five stages. One <span className="italic text-gold">partnership.</span>
                </h2>
                <p className="text-stone leading-relaxed mt-6 max-w-sm">
                  Every EQ Capital Group engagement begins with understanding your vision — then moves with intent from discovery through long-term growth.
                </p>
              </Reveal>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-hairline border-t border-hairline">
              {PROCESS.map((p, i) => (
                <Reveal key={p.n} delay={i * 0.05}>
                  <div className="group grid grid-cols-12 gap-6 py-10 hover:bg-surface/30 transition-colors duration-500 px-2">
                    <div className="col-span-3 sm:col-span-2">
                      <span className="font-serif font-light text-6xl lg:text-7xl text-hairline group-hover:text-gold transition-colors duration-500">{p.n}</span>
                    </div>
                    <div className="col-span-9 sm:col-span-10">
                      <h3 className="font-serif text-3xl lg:text-4xl font-light text-parchment tracking-tight">{p.title}</h3>
                      <p className="text-stone leading-relaxed mt-3 max-w-xl">{p.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
